/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:24/06/2021
 @Time:14:54
 **/
import {
    jarallax,
    jarallaxVideo
} from 'jarallax';
window.jarallax=jarallax;
window.jarallaxVideo=jarallaxVideo;
require ('particles.js');
import  particulesJson from './particles.json';
$(function() {
    particlesJS('particles-js',particulesJson);
});
//les compteurs incrémentation
$(function () {
    "use strict";

    jQuery(window).scroll(startCounter);
    function startCounter() {
        var hT = jQuery('.countnm-bx').offset().top,
            hH = jQuery('.countnm-bx').outerHeight(),
            wH = jQuery(window).height();
        if (jQuery(window).scrollTop() > hT+hH-wH) {
            jQuery(window).off("scroll", startCounter);
            jQuery('.countnm').each(function () {
                var $this = jQuery(this);
                jQuery({ Counter: 0 }).animate({ Counter: $this.text() }, {
                    duration: 2000,
                    easing: 'swing',
                    step: function () {
                        $this.text(Math.ceil(this.Counter) + '');
                    }
                });
            });
        }
    }

    //changement offre
    $("#abonnement-type").begroAjax({
        event:"change",
        ajaxURL: function(element){
            let type=$(element).is(":checked")?"service":"commerce";
            return Begro.getURL(`ajax/available-offre/${type}`);
        },
        successAjaxCallback: function (data,originalSource) {
            $(".offre").remove();
            $("#offre-container").prepend(data);
        }
    });
}); // End of use strict
